var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF0505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.98 15.52H9.74001L8.90001 18H5.32001L10.4 3.95999H14.36L19.44 18H15.82L14.98 15.52ZM14.1 12.88L12.36 7.73999L10.64 12.88H14.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentIcon);
export default __webpack_public_path__ + "static/media/urgent_icon.f3e54daffeb3b7ee01887eece66846ec.svg";
export { ForwardRef as ReactComponent };